import { useMemo } from "react";

export default function ProposalPage({ projectData, setProjectData }) {
  const {
    nomClient,
    nomProjet,
    montantGlobal,
    validiteJours,
    jalonsPaiement,
    enveloppeA,
    enveloppeB,
    chargeStructure,
    decisionEmission,
    notesInternes,
    planningPrevisionnel = "",
  } = projectData;

  function updateField(field, value) {
    setProjectData((prev) => ({
      ...prev,
      [field]: value,
    }));
  }

  const cardStyle = {
    border: "1px solid #ddd",
    borderRadius: 14,
    backgroundColor: "#fff",
    padding: 18,
  };

  const labelStyle = {
    fontWeight: 600,
    fontSize: 14,
    marginBottom: 6,
  };

  const inputStyle = {
    width: "100%",
    padding: "10px 12px",
    borderRadius: 10,
    border: "1px solid #d8d8d8",
    boxSizing: "border-box",
  };

  function toNumber(value) {
    return Number(value || 0);
  }

  function formatMoney(value) {
    return Number(value || 0).toLocaleString("fr-FR") + " MAD";
  }

  const analyse = useMemo(() => {
    const a = toNumber(enveloppeA);
    const b = toNumber(enveloppeB);
    const f = toNumber(montantGlobal);

    const alertes = [];
    const reserves = [];

    if (a <= 0) alertes.push("Enveloppe A non renseignée.");
    if (b <= 0) alertes.push("Enveloppe B non renseignée.");
    if (f <= 0) alertes.push("Forfait global non renseigné.");

    if (!jalonsPaiement.trim()) {
      reserves.push("Jalons de paiement non formalisés.");
    }

    if (!planningPrevisionnel.trim()) {
      reserves.push("Planning prévisionnel non renseigné.");
    }

    if (!chargeStructure.trim()) {
      reserves.push("Charge structure non évaluée.");
    }

    if (f > 0 && a > 0 && f < a) {
      alertes.push(
        "Le forfait global visible client ne peut pas être inférieur à l’Enveloppe A."
      );
    }

    if (String(validiteJours).trim() !== "15") {
      reserves.push("La validité standard YOMA est de 15 jours.");
    }

    let statut = "Proposition prête";
    let niveau = "ok";

    if (alertes.length > 0) {
      statut = "Proposition incomplète";
      niveau = "danger";
    } else if (reserves.length > 0) {
      statut = "Proposition à finaliser";
      niveau = "warning";
    }

    let message =
      "La proposition peut être émise sous forme écrite, avec un seul forfait global, un périmètre clair et une validité limitée.";

    if (niveau === "warning") {
      message =
        "La proposition est structurée, mais certains éléments doivent être finalisés avant émission.";
    }

    if (niveau === "danger") {
      message =
        "La proposition ne doit pas être émise tant que les éléments critiques ne sont pas verrouillés.";
    }

    return { alertes, reserves, statut, niveau, message };
  }, [
    enveloppeA,
    enveloppeB,
    montantGlobal,
    jalonsPaiement,
    planningPrevisionnel,
    chargeStructure,
    validiteJours,
  ]);

  function getBadgeStyle(niveau) {
    if (niveau === "ok") {
      return {
        backgroundColor: "#E8F6EF",
        color: "#1E8449",
        border: "1px solid #B7E1C1",
      };
    }

    if (niveau === "warning") {
      return {
        backgroundColor: "#FEF5E7",
        color: "#B9770E",
        border: "1px solid #F5CBA7",
      };
    }

    return {
      backgroundColor: "#FDEDEC",
      color: "#C0392B",
      border: "1px solid #F5B7B1",
    };
  }

  return (
    <main style={{ padding: 0 }}><div style={{ marginBottom: 20 }}><h1 style={{ marginBottom: 6 }}>Proposition Contractuelle</h1><p style={{ marginTop: 0 }}>
          Formalisation interne YOMA avant émission d’une proposition écrite au client
        </p></div><div
        style={{
          display: "grid",
          gridTemplateColumns: "1.1fr 0.9fr",
          gap: 20,
          alignItems: "start",
        }}
      ><div style={{ display: "grid", gap: 20 }}><div
            style={{
              ...cardStyle,
              border: "1px solid #C9A96E",
              backgroundColor: "#FFFDF8",
            }}
          ><h2 style={{ marginTop: 0 }}>Zone interne YOMA — confidentielle</h2><p style={{ marginTop: 0, color: "#7A5C1E", fontSize: 14 }}>
              Ces données ne doivent jamais apparaître dans un document client.
            </p><div style={{ display: "grid", gap: 14 }}><div><div style={labelStyle}>Nom du client</div><input
                  style={inputStyle}
                  value={nomClient}
                  onChange={(e) => updateField("nomClient", e.target.value)}
                /></div><div><div style={labelStyle}>Nom du projet</div><input
                  style={inputStyle}
                  value={nomProjet}
                  onChange={(e) => updateField("nomProjet", e.target.value)}
                /></div><div><div style={labelStyle}>Enveloppe A — Honoraires YOMA (MAD)</div><input
                  style={inputStyle}
                  value={enveloppeA}
                  onChange={(e) => updateField("enveloppeA", e.target.value)}
                /></div><div><div style={labelStyle}>Enveloppe B — Budget travaux réaliste (MAD)</div><input
                  style={inputStyle}
                  value={enveloppeB}
                  onChange={(e) => updateField("enveloppeB", e.target.value)}
                /></div><div><div style={labelStyle}>Charge structure</div><textarea
                  style={{ ...inputStyle, minHeight: 90, resize: "vertical" }}
                  value={chargeStructure}
                  onChange={(e) => updateField("chargeStructure", e.target.value)}
                  placeholder="Charge opérationnelle interne YOMA"
                /></div><div><div style={labelStyle}>Décision d’émission</div><select
                  style={inputStyle}
                  value={decisionEmission}
                  onChange={(e) => updateField("decisionEmission", e.target.value)}
                ><option value="">Sélectionner</option><option value="emettre">Émettre la proposition</option><option value="attendre">Attendre / compléter</option><option value="ne-pas-emettre">Ne pas émettre</option></select></div><div><div style={labelStyle}>Notes internes</div><textarea
                  style={{ ...inputStyle, minHeight: 110, resize: "vertical" }}
                  value={notesInternes}
                  onChange={(e) => updateField("notesInternes", e.target.value)}
                /></div></div></div><div style={cardStyle}><h2 style={{ marginTop: 0 }}>Cadre de proposition</h2><div style={{ display: "grid", gap: 14 }}><div><div style={labelStyle}>Forfait global visible client (MAD)</div><input
                  style={inputStyle}
                  value={montantGlobal}
                  onChange={(e) => updateField("montantGlobal", e.target.value)}
                /></div><div><div style={labelStyle}>Jalons de paiement</div><textarea
                  style={{ ...inputStyle, minHeight: 90, resize: "vertical" }}
                  value={jalonsPaiement}
                  onChange={(e) => updateField("jalonsPaiement", e.target.value)}
                  placeholder="Ex : 5 % à la signature, 30 % au démarrage, etc."
                /></div><div><div style={labelStyle}>Planning prévisionnel</div><textarea
                  style={{ ...inputStyle, minHeight: 90, resize: "vertical" }}
                  value={planningPrevisionnel}
                  onChange={(e) =>
                    updateField("planningPrevisionnel", e.target.value)
                  }
                /></div><div><div style={labelStyle}>Validité de la proposition (jours)</div><input
                  style={inputStyle}
                  value={validiteJours}
                  onChange={(e) => updateField("validiteJours", e.target.value)}
                /></div></div></div></div><div style={{ display: "grid", gap: 20 }}><div style={cardStyle}><h2 style={{ marginTop: 0 }}>Aperçu proposition client</h2><div style={{ marginBottom: 12 }}><strong>Projet :</strong> {nomProjet || "-"}
            </div><div style={{ marginBottom: 12 }}><strong>Montant global :</strong> {formatMoney(montantGlobal)}
            </div><div style={{ marginBottom: 12 }}><strong>Validité :</strong> {validiteJours || "-"} jours
            </div><div style={{ marginBottom: 12 }}><strong>Jalons de paiement :</strong><div style={{ marginTop: 6, whiteSpace: "pre-wrap" }}>
                {jalonsPaiement || "-"}
              </div></div><div
              style={{
                padding: 14,
                borderRadius: 10,
                backgroundColor: "#F8F8F8",
                borderLeft: "4px solid #C9A96E",
                marginBottom: 16,
              }}
            ><strong>Lecture interne YOMA :</strong><div style={{ marginTop: 8 }}>{analyse.message}</div></div></div><div style={cardStyle}><h2 style={{ marginTop: 0 }}>Contrôle interne</h2><div style={{ marginBottom: 16 }}><span
                style={{
                  ...getBadgeStyle(analyse.niveau),
                  borderRadius: 999,
                  padding: "8px 12px",
                  fontWeight: 700,
                }}
              >
                {analyse.statut}
              </span></div>

            {analyse.alertes.length > 0 && (
              <div style={{ marginBottom: 14 }}><strong>Alertes :</strong><ul>
                  {analyse.alertes.map((item) => (
                    <li key={item}>{item}</li>
                  ))}
                </ul></div>
            )}

            {analyse.reserves.length > 0 && (
              <div style={{ marginBottom: 14 }}><strong>Réserves :</strong><ul>
                  {analyse.reserves.map((item) => (
                    <li key={item}>{item}</li>
                  ))}
                </ul></div>
            )}
          </div><div style={cardStyle}><h2 style={{ marginTop: 0 }}>Rappel structurel</h2><ul style={{ margin: 0, paddingLeft: 18 }}><li>Le client ne voit jamais Enveloppe A ni Enveloppe B.</li><li>Le client voit uniquement le forfait global et les jalons.</li><li>La validité standard YOMA est de 15 jours.</li><li>Une seule proposition est émise.</li></ul></div></div></div></main>
  );
}